import React from "react";

import TextInput from "@peracto/peracto-editor-ui/dist/TextInput";
import File from "@peracto/peracto-editor-ui/dist/File";
import Select from "@peracto/peracto-editor-ui/dist/Select";
import Checkbox from "@peracto/peracto-editor-ui/dist/Checkbox";

const HeroForm = ({
    onChange,
    state: {
        url = "",
        mobileUrl = "",
        backgroundType = "image",
        heroHeading = "",
        heroHeadingColour = "text-brand-black",
        heroText = "",
        heroLink = "",
        heroButtonText = "",
        heroButtonLink = "",
        heroButtonColour = "primary",
        showCallbirdButton = false,
    },
}) => {
    const backgroundTypeOptions = [
        { label: "Image", value: "image" },
        { label: "Video", value: "video" },
    ];

    const buttonColourOptions = [
        { label: "Blue", value: "primary" },
        { label: "Orange", value: "tertiary" },
        { label: "Green", value: "sextary" },
        { label: "Pink", value: "quaternary" },
        { label: "Yellow", value: "quinary" },
    ];

    const heroHeadingColourOptions = [
        { label: "Black", value: "text-brand-black" },
        { label: "White", value: "text-brand-white" },
        { label: "Blue", value: "text-brand-primary" },
        { label: "Orange", value: "text-brand-secondary" },
        { label: "Green", value: "text-brand-tertiary" },
        { label: "Pink", value: "text-brand-quaternary" },
        { label: "Yellow", value: "text-brand-quinary" },
    ];

    return (
        <>
            <Select
                label="Background Type"
                value={backgroundType}
                onChange={(e) => onChange({ backgroundType: e.value })}
                options={backgroundTypeOptions}
            />

            <File
                label={`${backgroundType === "image" ? "Image" : "Video"} URL`}
                value={url}
                onChange={(value) => onChange({ url: value })}
                isInline={false}
            />

            <TextInput
                label="Hero Heading"
                value={heroHeading}
                onChange={(e) => onChange({ heroHeading: e.target.value })}
            />

            <Select
                label="Hero Heading Colour"
                value={heroHeadingColour}
                onChange={(e) => onChange({ heroHeadingColour: e.value })}
                options={heroHeadingColourOptions}
            />

            <TextInput
                label="Hero Text"
                value={heroText}
                onChange={(e) => onChange({ heroText: e.target.value })}
            />

            <TextInput
                label="Hero Button Text"
                value={heroButtonText}
                onChange={(e) => onChange({ heroButtonText: e.target.value })}
            />

            <TextInput
                label="Hero Button Link"
                value={heroButtonLink}
                onChange={(e) => onChange({ heroButtonLink: e.target.value })}
            />

            <Select
                label="Hero Button Colour"
                value={heroButtonColour}
                onChange={(e) => onChange({ heroButtonColour: e.value })}
                options={buttonColourOptions}
            />

            <Checkbox
                label="Show Callbird Button"
                checked={showCallbirdButton}
                onChange={(e) =>
                    onChange({ showCallbirdButton: e.target.checked })
                }
            />
        </>
    );
};

export default HeroForm;
